module.exports = __webpack_public_path__ + "static/img/water-extractor_256.e62095d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/water-extractor_256.png
// module id = rQif
// module chunks = 0